import AbstractPerson from './AbstractPerson'
import { Forschungsprojekt } from 'fobclient/lib/entity'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Forschungsprojekt')

export default {
  label: 'Forschungsprojekt',
  route: 'forschungsprojekt',
  class: Forschungsprojekt,
  className: 'forschungsprojekt',
  fields: [
    Fields.organisationseinheit,
    Fields.relevantFuerWeitere,
    Fields.weitereOrganisationseinheiten,
    {
      ...Fields.String('primaryPublicIdent'),
      inEditView: false,
      editable: false,
      inPublicView: false,
      type: 'link',
      computed (data) {
        if (data.primaryPublicIdent) {
          return {
            href: `${process.env.LEURIS_BASE_URI}/portal/details/forschungsprojekt/${data.primaryPublicIdent}`,
            text: data.primaryPublicIdent,
          }
        }
        return null
      }
    },
    Fields.String('titelDE'),
    Fields.String('titelEN'),
    Fields.Text('beschreibungDE', 6000),
    Fields.Text('beschreibungEN', 6000),
    Fields.Date('projektBeginn'),
    Fields.Date('projektEnde'),
    {
      label: 'Forschungsprojekt.form.antragsteller',
      field: 'antragsteller',
      schema: AbstractPerson,
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      },
      icon: 'user',
      type: 'object',
      cardinality: 'many',
      render: 'stringRep'
    },
    // old projektLeiter, replaced by projektleiter
    /*
    {
      label: 'Forschungsprojekt.form.projektLeiter',
      field: 'projektLeiter',
      schema: AbstractPerson,
      icon: 'user',
      type: 'object',
      cardinality: 'single',
      render: 'stringRep',
      allowCreate: true,
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      }
    },
    */
    {
      label: 'Projektleitung',
      field: 'projektleiter',
      /*
        - a key `schema` is not needed since the projektleiter components
          come with their custom hard-coded layout of fields
        - a key `icon` is not needed, because there is no input field
        - render mode 'projektleiter' is a new custom-built mode
      */
      type: 'object',
      cardinality: 'many',
      render: 'projektleiter',
      allowCreate: true,
      onlyCreate: true,
    },
    Fields.URL('externeProjektwebsite'),
    Fields.String('uebergeordnetesProjekt'),
    {
      label: 'Forschungsprojekt.form.mitarbeiter',
      field: 'mitarbeiter',
      render: 'stringRep',
      type: 'object',
      schema: AbstractPerson,
      icon: 'user',
      cardinality: 'many',
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 3
      }
    },
    {
      label: 'Forschungsprojekt.form.finanzierung',
      field: 'foerderung',
      type: 'object',
      render: 'embedded',
      cardinality: 'many',
      nested: true,
      onlyCreate: true,
      schema: {
        route: 'foerderung',
        className: 'foerderung',
        entityName: 'de.ul.fob.domain.Foerderung',
        fields: [
          {
            label: 'Forschungsprojekt.form.foerderung.mittelgeber',
            field: 'mittelgeber',
            type: 'object',
            cardinality: 'single',
            nested: true,
            /*
            nested: take route 'foerderung' and nest 'mittelgeber' after that
            absolutely confusing! this has to be changed
            idea: 'nested' holds the path continuation, if any

            route is not relevant for nested! route is only for stand-alone

            main problem was:
            fetchResource is used to resolve 'embedded' references like book/author as
            well as direct resources ('person')
            */
            schema: {
              route: 'mittelgeber',
              className: 'mittelgeber',
              fields: [
                {
                  label: 'Name',
                  field: 'name'
                }
              ]
            },
            finder: {
              name: 'bySearchRepLike',
              multiValue: false,
              minLength: 0,
              opts: {
                sort: 'finSchluessel'
              }
            }
          },
          {
            field: 'logo',
            view: () => false,
            computed: (data) => {
              if (['000', '200', '300', '310', '320', '410', '420', '430'].includes(data.mittelgeber.finSchluessel)) {
                return `/static/logos/${data.mittelgeber.finSchluessel}.jpg`
              } else if (data.mittelgeber.finSchluessel === '110') {
                return '/static/logos/BMFTR_Logo_de.svg'
              } else if (data.mittelgeber.finSchluessel === '120') {
                return '/static/logos/BMWE_Logo_de.svg'
              } else {
                return null
              }
            }
          },
          {
            label: 'Forschungsprojekt.form.foerderung.foerderkennzeichen',
            field: 'foerderkennzeichen',
            inPublicView: false
          }
        ]
      }
    },
    {
      ...Fields.MultiReference('sdg', 'bullseye'),
      plain: true,
      view (data, user, isPublic) {
        return !isPublic || data.sdg.length > 0
      },
      schema: {
        route: 'sdg',
        className: 'sdg',
        fields: [
          {
            field: 'nameDe',
            table: true
          },
          {
            field: 'nameEn',
            table: true
          }
        ],
        tableSelectColumns: [
          {
            label: '_stringRep',
            field: '_stringRep'
          }
        ],
      },
      finder: {
        name: 'byMultiValueSearchRep',
        multiValue: true,
        minLength: 0,
      },
      widget: 'tableSelectVertical',
      allowCreate: false,
    },
    Fields.Boolean('verbundprojekt'),
    {
      label: 'Forschungsprojekt.form.sprecherhochschule',
      field: 'sprecherhochschule',
      render: 'stringRep',
      type: 'object',
      cardinality: 'single',
      schema: {
        route: 'externeorganisation',
        className: 'externeOrganisation'
      },
      finder: {
        name: 'bySearchRepLike',
        multiValue: false,
        minLength: 0
      },
      view (data, user) {
        return data.verbundprojekt
      }
    },
    {
      label: 'Forschungsprojekt.form.publikation',
      field: 'publikation',
      schema: {
        className: 'publikation'
      },
      render: 'stringRep',
      type: 'object',
      cardinality: 'many',
      editable: false
    },
    {
      label: 'Forschungsprojekt.form.istFinal',
      field: 'istFinal',
      inPublicView: false,
      type: Boolean
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Forschungsprojekt.js